/**
 * BookingGateway の Supabase 実装（RPC 専用）。
 *
 * Postgres 関数 optimistic_lock_booking を呼び、supabase のエラーを
 * ドメインの競合エラー（Error("CONFLICT")）へ翻訳する。
 */
import { supabase } from "@/integrations/supabase/client";
import type { BookingGateway } from "@/domain/repositoryInterface/BookingGateway";

export class SupabaseBookingGateway implements BookingGateway {
  async optimisticLockUpdate(params: {
    id: string;
    expectedUpdatedAt: string;
    updates: Record<string, unknown>;
  }): Promise<unknown> {
    const { data, error } = await supabase.rpc("optimistic_lock_booking", {
      p_id: params.id,
      p_expected_updated_at: params.expectedUpdatedAt,
      p_updates: params.updates as unknown as Record<string, never>,
    });

    if (error) {
      if (error.code === "40001" || error.message?.includes("CONFLICT")) {
        throw new Error("CONFLICT");
      }
      throw error;
    }
    return data;
  }
}
